import React from 'react';
import { observer } from 'mobx-react';
import { DeckUI } from '@seedlang/state';
import ConceptDescription from './concept_description';
import styled from '@emotion/styled';
import SentenceBreakdown from 'components/sentence_breakdown';
import TextResizer from 'components/text_resizer';
import { flexCenterColumn } from '@seedlang/style_mixins';

const ScrollContainer = styled.div`
  height: ${props => props.fullHeight ? '100%' : 'calc(100% - 140px)'};
  overflow: auto;
  padding-bottom: 20px;
`;

const SentenceWrapper = styled.div`
  ${flexCenterColumn()}
  height: 140px;
  background: #E6E6E6;
  border-top: 2px solid #CCC;
  padding-bottom: 20px;
`;

@observer
class ConceptDescriptionWithSentence extends React.Component {

  render() {
    const hasSentence = !!DeckUI.currentSentence;

    return (
      <>
        <ScrollContainer fullHeight={!hasSentence}>
          {
            DeckUI.currentCard.concept &&
              <ConceptDescription
                concept={DeckUI.currentCard.concept}
              />
          }
        </ScrollContainer>
        {
          DeckUI.currentSentence &&
          <SentenceWrapper>
            <TextResizer
              resizeText
              maximumFontSize={30}
              height={100}
              width={DeckUI.layout.innerDeckWidth - 20}
              characterLength={DeckUI.currentSentence.targetText && DeckUI.currentSentence.targetText.length}
            >
              <SentenceBreakdown
                center
                showUnderline={DeckUI.currentCardState.revealed}
                showCase={DeckUI.currentCardState.revealed}
                sentence={DeckUI.currentSentence}
                hideTextInput={!DeckUI.currentCardState.revealed}
                highlightType='background'
                highlightWordAssociationIds={DeckUI.currentCardState.revealed ? DeckUI.currentCard.wordAssociationIds : []}
                inputWordAssociationIds={DeckUI.currentCardState.revealed ? [] : DeckUI.currentCard.wordAssociationIds}
                disableOnClick
                defaultBorderColor="#b0b0b0"
              />
            </TextResizer>
          </SentenceWrapper>
        }
      </>
    );
  }
}

export default ConceptDescriptionWithSentence;